import { helper } from "src/utils/helper";
import i18n from ".";

export const translate = (key: TKeyType, defaultValue: string): string => {
  if (!defaultValue)
    return defaultValue;
  return i18n.t(key + "|" + helper.camelCase(defaultValue), defaultValue);
}
type TKeyType =
  "common" |
  "pages|definitions" |
  "pages|laboratuvarIzleme" |
  "pages|labSonuc" |
  "pages|hastaServis" |
  "pages|raporlama" |
  "pages|teleDiagnosisTanim" |
  "pages|kurumTanim" |
  "pages|kurumGrup" |
  "pages|ucretTarifeTanim" |
  "pages|organizasyonTanim" |
  "pages|islemTanim|islemRapor" |
  "pages|islemTanim|islemRapor|form" |
  "pages|hastaDosyalari" |
  "pages|islemTanimlari" |
  "pages|hastaRecete" |
  "pages|hastaServis|order" |
  "pages|hastaServis|order|liste" |
  "pages|hastaServis|order|ilac" |
  "pages|hastaServis|order|patoloji" |
  "pages|hastaServis|order|ameliyat" |
  "pages|hastaServis|order|laboratuvar" |
  "pages|hastaServis|order|radyoloji" |
  "pages|hastaServis|order|mailAyarlari" |
  "pages|hastaServis|order|radyoloji" |
  "pages|protokolGrup" |
  "pages|hastaServis|order|konsultasyon" |
  "parts|hizmet|islemRaporlari" |
  "pages|genelTanimlar|yatakTanim" |
  "pages|patoloji|numuneKabul" |
  "pages|patoloji|laboratuvarIslemleri" |
  "pages|patoloji|raporIslemleri" |
  "pages|patoloji|raporIslemleri|RaporMailGonderim" |
  "pages|patoloji|arsivleme" |
  "pages|patoloji|patolojiRaporKurtarma" |
  "pages|kurumDisi|kargoKuryeTakip" |
  "pages|hastaServis|order|mailOnTanimlari" |
  "pages|hastaServis|order|mailGonderim" |
  "pages|raporTipleriGirisYetkiKontrol" |
  "parts|raporTipleri" |
  "parts|raporTipTanim" |
  "parts|hastaArama" |
  "parts|islemler" |
  "pages|patoloji" |
  "pages|testDetayBilgisi" |
  "pages|genelTanimlar|istemPanel" |
  "parts|aramaKriterleri" |
  "components|iconbtn" |
  "components|editor" |
  "parts|sablonAktar" |
  "parts|morfoloji" |
  "pages|muhasebeIslemler|form" |
  "pages|muhasebeIslemler|list|" |
  "pages|muhasebeIslemler|detay|form" |
  "pages|muhasebeIslemler|detay|list" |
  "pages|muhasebeIslemler|yilOrgSecimDialog" |
  "pages|muhasebeIslemler|index" |
  "pages|muhasebeIslemler|detay|index" |
  "pages|iptalNedenSecim" |
  "pages|kimlik" |
  "pages|login" |
  "pages|faturaModulu|kurumIcmalleri" |
  "pages|hastaKayit|form" |
  "pages|patoloji|hastaRaporSonuclari" |
  "parts|hastaRaporSonuclari" |
  "pages|stokEczane" |
  "pages|radyolojiModulu|radyolojikabul" |
  "pages|radyolojiModulu|radyolojiislemler" |
  "pages|radyolojiModulu|cihazRandevu" |
  "pages|servisTanim" |
  "pages|servisTanim" |
  "pages|depoTalep" |
  "pages|depoTalep|depoDurumList" |
  "pages|kullanici|kullaniciVTYS" |
  "pages|IstemPanel|IlacPano" |
  "parts|mesaj" |
  "pages|drHakedis" |
  "pages|stokEczane|depoDurum" |
  "pages|stokEczane|depoDurum|aramaKriterleri" |
  "pages|stokEczane|depoDurum|ilacListesi" |
  "pages|stokEczane|depoDurum|depoGirisCikisDurum" |
  "pages|stokEczane|depoDurum|depoGirisCikisDurum|cikisHareketler" |
  "pages|stokEczane|depoDurum|depoGirisCikisDurum|girisHareketler" |
  "pages|hastaKayit" |
  "pages|sonucIzleme" |
  "pages|hastaTani" |
  "parts|tani" |
  "pages|taniTanim" |
  "pages|mailGonderimIzleme" |
  "pages|sablonTanimlari" |
  "pages|kullaniciTanim" |
  "pages|vezne" |
  "parts|kurumGruplari" |
  "parts|parametre" |
  "parts|kurum" |
  "pages|sozlesmeIzleme" |
  "parts|vezne" |
  "parts|servisPersonel" |
  "pages|stokEczane|cikisIslemleri" |
  "pages|stokEczane|cikisIslemleri|cikisList" |
  "pages|stokeczane|girisislemleri|girisList" |
  "pages|parametre" |
  "pages|stokeczane|girisislemleri|girisEkle" |
  "pages|stokeczane|cikisislemleri|cikisEkle" |
  "pages|stokeczane|cikisislemleri|cikisEkle|cikisDetay" |
  "pages|stokeczane|cikisislemleri|cikisDetayList" |
  "parts|servisPersonel" |
  "pages|hataliktanim" |
  "pages|stokEczane|orderTalep|redNedenKontrol" |
  "pages|stokEczane|orderTalep|OrderTalepAramaKriterleri" |
  "pages|stokeczane|yetkiislemleri|deposecimdialog" |
  "pages|stokeczane|depotanimlari|depoTanimEkle" |
  "pages|stokeczane|uruntanimlari|urunDuzenle" |
  "pages|bransTanim" |
  "pages|urunTanim" |
  "pages|depoTanim" |
  "pages|stok" |
  "parts|vezne" |
  "parts|kayitTipi" |
  "pages|stokeczane|cikisislemleri|cikisDetayList" |
  "pages|stokeczane|cikisislemleri|urunSecEkle|urunSecList" |
  "parts|organizasyonBirim" |
  "pages|tedavi|ilacMalzeme" |
  "pages|tedavi|tedaviUygulama" |
  "pages|stokEczane|OrderTalepKarsila|OrderTalepListDetay" |
  "pages|stokEczane|OrderTalepKarsila|OrderTalepKimlikDetay" |
  "pages|stokEczane|OrderTalepKarsila|OrderTalepKabul" |
  "pages|stokEczane|OrderTalepKarsila|OrderTalepHastaList" |
  "pages|stokEczane|OrderTalepKarsila|OrderTalepDetayBilgileri" |
  "pages|stokEczane|OrderTalepKarsila|OrderTalepAramaKriterleri" |
  "pages|stokEczane|OrderTalepKarsila|OrderServisList" |
  "pages|stokEczane|OrderTalepKarsila|OrderTalep" |
  "pages|stokEczane|DepoTalepKarsila|DepoTalepList" |
  "pages|stokEczane|DepoTalepKarsila|DepoTalepKabulForm" |
  "pages|stokEczane|DepoTalepKarsila|DepoTalepDetayList" |
  "pages|stokEczane|DepoTalepKarsila|DepoTalepAramaKriterleri" |
  "pages|stokEczane|OrderTalepKarsila|OrderOnayliListesi" |
  "pages|stokEczane|OrderTalepKarsila|OrderOnayliIlaclarListesi" |
  "pages|stokEczane|OrderTalepKarsila|OrderOnayliAramaKriterleri" |
  "pages|stokEczane|OrderTalepKarsila|OrderIptalListesi" |
  "pages|stokEczane|OrderTalepKarsila|OrderIptalAramaKriterleri" |
  "pages|stokEczane|OrderTalepKarsila|OrderHastaCikisDetaylari" |
  "pages|hemsireIsliste" |
  "pages|hemsireIsliste|HastaListesi" |
  "pages|hemsireIsliste|UygulamaListesi" |
  "pages|hemsireIsliste|UygulamaForm" |
  "pages|rezervBarkod|barkodNo" |
  "pages|randevu" |
  "pages|kurumTarife" |
  "pages|hastaKayit|hastaMuracaat|grdhastaServis" |
  "pages" |
  "pages|borcTaahhut" |
  "pages|duyuru" |
  "pages|fatura" |
  "pages|fatura|arama" |
  "pages|fatura|faturaDetay" |
  "pages|fatura|faturaToolbar" |
  "pages|fatura|hastaGrid" |
  "pages|fatura|hastaServis" |
  "pages|fatura|islem" |
  "pages|fatura|islemToolbar" |
  "pages|fatura|izlemeEkrani" |
  "pages|kimlik|kimlikinfo" |
  "pages|faturaTanim" |
  "pages|personel" |
  "pages|personel|validation" |
  "pages|referansDoktor" |
  "pages|genelTanimlar|servisProtokolTanim" |
  "pages|paketTanim" |
  "pages|girisIslemleri" |
  "pages|stokEczane|orderTalep" |
  "pages|ucretTarifeIslem" |
  "pages|yatisKabul" |
  "pages|kullanicirolyetki" |
  "pages|yetki|vezneYetki" |
  "pages|hastaSiviDenge" |
  "pages|kararDestek" |
  "pages|kullaniciTarife" |
  "pages|hataKayitlari" |
  "common|sessionExpiration" |
  "common|vezneKullaniciAutocomplete" |
  "pages|muracaatIzlem" |
  "pages|hesapPlanTanim" |
  "pages|organizasyonTarife" |
  "pages|organizasyonYetki" |
  "pages|rezervBarkod" |
  "pages|rolYetki" |
  "pages|servisPersonelYetki" |
  "pages|dilIslemleri" |
  "pages|kurumTarife" |
  "pages|modulTanim" |
  "pages|rolTanim" |
  "pages|ucretTarifeTanim" |
  "pages|veriKontrol" |
  "pages|indirimTanim" |
  "pages|kullaniciVarsayilanMenu" |
  "component|recordInfo" |
  "pages|vezneTanim" |
  "pages|stokeczane|cikisislemleri|depoSeciniz" |
  "pages|stokeczane|depotanimlari|depotanimsearch" |
  "pages|eczanestok|depotanimlari|sorumluPersonel" |
  "pages|eczanestok|depotanimlari|depoTipi" |
  "pages|eczanestok|depotanimlari|aktif" |
  "pages|eczanestok|depotanimlari|pasif" |
  "pages|eczanestok|depotanimlari|tumu" |
  "pages|stokeczane|girisislemleri|girisEkle|girisDetay" |
  "pages|stokeczane|girisislemleri|girisdetaydialog" |
  "pages|stokeczane|girisislemleri|index" |
  "pages|stokeczane|girisislemleri|muracaat" |
  "pages|hastaServis" |
  "pages|menu|breadCrumbs" |
  "pages|menu|items" |
  "pages|kurumBonusTanimlari" |
  "pages|yetkiTanim" |
  "pages|KurumMailGonderimAyarlari" |
  "pages|patoloji|header" |
  "pages|hastaUyari" |
  "pages|hastaUyariListesi" |
  "pages|genelTanimlar|sonucIzlemeTanim" |
  "parts|sonucDegerleri" |
  "pages|redPanik" |
  "applications|testYinele"